import { router } from "@inertiajs/react";
import { useCallback } from "react";
import { useSafePostHog } from "@hooks/use_posthog";
import type { SearchParams } from "@/pages/job_search";
import type { VisitOptions } from "@inertiajs/core";

export function useJobSearch() {
  const posthog = useSafePostHog();

  return useCallback(
    (params: SearchParams, options?: VisitOptions) => {
      posthog?.capture("job_search_submitted", {
        ...params,
        path: window.location.pathname,
      });

      router.get("/jobs", params, options);
    },
    [posthog],
  );
}
